import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ' border-radius: ', 'px;\n  display: flex;\n  transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out;\n  ', ' &:hover {\n    ', ';\n  }\n'], ['\n  ', ' border-radius: ', 'px;\n  display: flex;\n  transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out;\n  ', ' &:hover {\n    ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  flex-basis: 0;\n  flex-grow: 1;\n'], ['\n  flex-basis: 0;\n  flex-grow: 1;\n']);

import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import { mergeStyles } from '@atlaskit/select';
import { borderRadius, colors } from '@atlaskit/theme';
import pick from 'lodash.pick';
import React, { Component } from 'react';
import styled from 'styled-components';

import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import { parseDateIntoStateValues } from '../internal';

/* eslint-disable react/no-unused-prop-types */


/** Border style is defined by the appearnace and whether it is invalid. */
function getBorderStyle(isInvalid, appearance) {
  if (isInvalid) return '2px solid ' + colors.R400;
  if (appearance === 'subtle') return '2px solid transparent';
  return '1px solid ' + colors.N20;
}
/** Padding style is defined by the appearnace and whether it is invalid. */
function getPaddingStyle(isFocused, appearance) {
  if (appearance === 'subtle' || !isFocused) return '1px';
  return '0px';
}

var Flex = styled.div(_templateObject, function (_ref) {
  var appearance = _ref.appearance;
  return '\n    background-color: ' + (appearance === 'subtle' ? 'transparent' : colors.N10) + '\n    };\n  ';
}, borderRadius(), function (_ref2) {
  var isFocused = _ref2.isFocused,
      isInvalid = _ref2.isInvalid,
      appearance = _ref2.appearance;
  return '\n    border: ' + (isFocused ? '2px solid ' + colors.B100 : '' + getBorderStyle(isInvalid, appearance)) + ';\n    padding: ' + getPaddingStyle(isFocused, appearance) + ';\n  ';
}, function (_ref3) {
  var isFocused = _ref3.isFocused,
      isDisabled = _ref3.isDisabled;
  return !isFocused && !isDisabled ? '\n        background-color: ' + colors.N20 + ';\n      ' : '';
});

var FlexItem = styled.div(_templateObject2);

// react-select overrides (via @atlaskit/select).
var styles = {
  control: function control(style) {
    return _extends({}, style, {
      backgroundColor: 'transparent',
      border: 2,
      borderRadius: 0,
      paddingLeft: 0,
      ':hover': {
        backgroundColor: 'transparent'
      }
    });
  }
};

function formatDateTimeZoneIntoIso(date, time, zone) {
  return date + 'T' + time + zone;
}

var DateTimePicker = function (_Component) {
  _inherits(DateTimePicker, _Component);

  function DateTimePicker() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, DateTimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = DateTimePicker.__proto__ || _Object$getPrototypeOf(DateTimePicker)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      active: 0,
      dateValue: '',
      isFocused: false,
      timeValue: '',
      value: _this.props.defaultValue,
      zoneValue: ''
    }, _this.getState = function () {
      var mappedState = _extends({}, _this.state, pick(_this.props, ['value']));

      return _extends({}, mappedState, parseDateIntoStateValues(mappedState.value, mappedState.dateValue, mappedState.timeValue, mappedState.zoneValue));
    }, _this.onBlur = function () {
      _this.setState({ isFocused: false });
      _this.props.onBlur();
    }, _this.onDateChange = function (dateValue) {
      _this.onValueChange(_extends({}, _this.getState(), { dateValue: dateValue }));
    }, _this.onFocus = function () {
      _this.setState({ isFocused: true });
      _this.props.onFocus();
    }, _this.onTimeChange = function (timeValue) {
      _this.onValueChange(_extends({}, _this.getState(), { timeValue: timeValue }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // All state needs to be accessed via this function so that the state is mapped from props
  // correctly to allow controlled/uncontrolled usage.


  _createClass(DateTimePicker, [{
    key: 'onValueChange',
    value: function onValueChange(_ref5) {
      var dateValue = _ref5.dateValue,
          timeValue = _ref5.timeValue,
          zoneValue = _ref5.zoneValue;

      this.setState({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue });
      if (dateValue && timeValue) {
        var _value = formatDateTimeZoneIntoIso(dateValue, timeValue, zoneValue);
        this.setState({ value: _value });
        this.props.onChange(_value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          id = _props.id,
          innerProps = _props.innerProps,
          isDisabled = _props.isDisabled,
          name = _props.name,
          timeIsEditable = _props.timeIsEditable,
          dateFormat = _props.dateFormat,
          datePickerSelectProps = _props.datePickerSelectProps,
          timePickerSelectProps = _props.timePickerSelectProps;

      var _getState = this.getState(),
          isFocused = _getState.isFocused,
          value = _getState.value,
          dateValue = _getState.dateValue,
          timeValue = _getState.timeValue;

      var icon = this.props.appearance === 'subtle' || this.props.hideIcon ? null : CalendarIcon;
      var bothProps = {
        isDisabled: isDisabled,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        isInvalid: this.props.isInvalid,
        appearance: this.props.appearance
      };

      var _ref6 = datePickerSelectProps,
          _ref6$styles = _ref6.styles,
          datePickerStyles = _ref6$styles === undefined ? {} : _ref6$styles;
      var _ref7 = timePickerSelectProps,
          _ref7$styles = _ref7.styles,
          timePickerStyles = _ref7$styles === undefined ? {} : _ref7$styles;


      var mergedDatePickerSelectProps = _extends({}, datePickerSelectProps, {
        styles: mergeStyles(styles, datePickerStyles)
      });

      var mergedTimePickerSelectProps = _extends({}, timePickerSelectProps, {
        styles: mergeStyles(styles, timePickerStyles)
      });

      return React.createElement(
        Flex,
        _extends({}, innerProps, {
          isFocused: isFocused,
          isDisabled: isDisabled,
          isInvalid: bothProps.isInvalid,
          appearance: bothProps.appearance
        }),
        React.createElement('input', { name: name, type: 'hidden', value: value }),
        React.createElement(
          FlexItem,
          null,
          React.createElement(DatePicker, _extends({}, bothProps, {
            autoFocus: autoFocus,
            dateFormat: dateFormat,
            icon: null,
            id: id,
            onChange: this.onDateChange,
            selectProps: mergedDatePickerSelectProps,
            value: dateValue
          }))
        ),
        React.createElement(
          FlexItem,
          null,
          React.createElement(TimePicker, _extends({}, bothProps, {
            icon: icon,
            onChange: this.onTimeChange,
            selectProps: mergedTimePickerSelectProps,
            defaultValue: timeValue,
            timeIsEditable: timeIsEditable
          }))
        )
      );
    }
  }]);

  return DateTimePicker;
}(Component);

DateTimePicker.defaultProps = {
  appearance: 'default',
  autoFocus: false,
  isDisabled: false,
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  innerProps: {},
  id: '',
  defaultValue: '',
  timeIsEditable: false,
  isInvalid: false,
  hideIcon: false,
  datePickerSelectProps: {},
  timePickerSelectProps: {}
};
export default DateTimePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/dist/esm/components/DateTimePicker.js
// module id = 615
// module chunks = 0